import { MUIButton, Notification } from '@abb/arcadia-ui-react';
import * as ActionCreators from '@module/license/actionCreators/hardwareActionCreators';
import { IServer, Server } from '@module/license/models';
import { API_ERROR_MESSAGE, API_SUPPORT_EMAIL } from '@service/constants';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import { default as ServerTable } from './HardwareTable';

/* tslint:disable:jsx-no-lambda jsx-no-multiline-js jsx-self-close*/
export class ServerTableContainer extends React.Component<any, any> {
  render() {
    const canAddHardware = !this.props.hardwareIsEditing;
    const errorMessage =
      <div hidden={!this.props.serverErrorMessageVisible}>
        <Notification variant='error' isBanner={true} open={this.props.serverErrorMessageVisible} id='errorBanner'
          primaryText={API_ERROR_MESSAGE} secondaryText={API_SUPPORT_EMAIL}
          onClose={() => { this.props.clearErrorMessage(); }} />
      </div>;

    const button = (<div className='col-md-4 text-right '>
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_add' label='Add Hardware' disabled={!canAddHardware} onClickButton={() => { this.props.AddNewEditableRow(new Server(), this.props.match.params.siteId); }} />
    </div>);

    return (
      <div className='container container-style card-container'>
        <div className='row bottom-buffer flex-between'>
          <div className='col-md-8'>
            <h3>Hardware</h3>
          </div>
          {button}
        </div>
        {errorMessage}
        <div className='bs'>
          <div className='row'>
            <div className='col-md-12'>
              <ServerTable {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServerTableContainer) as any);

export function mapStateToProps(store: { serverState: any; userState: { loggedInUser: { access_token: string } }; permissionsState: any }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.serverState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    AddNewEditableRow: (server: IServer[], siteId: number) => dispatch(ActionCreators.onAddNewEditableRow(server, siteId)),
    EditExistingRow: (server: IServer) => {
      dispatch(ActionCreators.onEditExistingRow(server));
    },
    ServerCancelEdit: (server: IServer) => dispatch(ActionCreators.onServerCancelEdit(server)),
    authenticatedUpdateServer: (server: IServer, accessToken: string) => {
      if (server.description.valid && server.serverId.valid) {
        dispatch(ActionCreators.onUpdateServer(server, accessToken));
      }
      // TODO: else statement
    },
    ServerDescriptionEdit: (updatedDescription: string) => {
      dispatch(ActionCreators.onServerDescriptionEdit(updatedDescription));
    },
    ServerServerIdEdit: (updatedServerId: string) => {
      dispatch(ActionCreators.onServerServerIdEdit(updatedServerId.toUpperCase()));
    },
    ServerOperationUseChange: (value: any) => {
      dispatch(ActionCreators.onServerOperationalUseChange(value));
    },
    authenticatedDeleteServer: (server: IServer, accessToken: string) => dispatch(ActionCreators.onDeleteServer(server, accessToken)),
    clearErrorMessage: () => dispatch(ActionCreators.clearErrorMessage())
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, { authenticatedUpdateServer, authenticatedDeleteServer, AddNewEditableRow, ServerCancelEdit, EditExistingRow, ServerDescriptionEdit, ServerServerIdEdit, ServerOperationUseChange, clearErrorMessage, ...propsFromDispatch }: any, ownProps: any) {
  const UpdateServer = (server: IServer) => authenticatedUpdateServer(server, accessToken);
  const DeleteServer = (server: IServer) => authenticatedDeleteServer(server, accessToken);
  return {
    ...propsFromState,
    ...ownProps,
    UpdateServer,
    DeleteServer,
    AddNewEditableRow,
    ServerCancelEdit,
    ServerDescriptionEdit,
    ServerServerIdEdit,
    ServerOperationUseChange,
    EditExistingRow,
    clearErrorMessage
  };
}
